<material-navbar menuPosition="admin-navbar" [showToggleButton]="true" (toggleButtonClick)="toggleLeftSidebar()"></material-navbar>

<mat-sidenav-container class="admin-page-content">
    <mat-sidenav [opened]="!leftColumnIsHidden" [mode]="(breakpoints.isMobile$ | async) ? 'over' : 'side'" [fixedInViewport]="true" [fixedTopGap]="70" class="left-column">
        <div class="menu-items">
            <a class="menu-item" routerLink="analytics" *ngIf="currentUser.hasPermission('reports.view')" routerLinkActive="router-link-active">
                <mat-icon svgIcon="pie-chart"></mat-icon>
                <span trans>Analytics</span>
            </a>
            <a class="menu-item" routerLink="appearance" *ngIf="currentUser.hasPermission('appearance.update')" routerLinkActive="router-link-active">
                <mat-icon svgIcon="style"></mat-icon>
                <span trans>Appearance</span>
            </a>
            <a class="menu-item" routerLink="settings" *ngIf="currentUser.hasPermission('settings.view')" routerLinkActive="router-link-active">
                <mat-icon svgIcon="settings"></mat-icon>
                <span trans>Settings</span>
            </a>

            <ng-container *ngIf="settings.get('billing.enable')">
                <a class="menu-item" routerLink="plans" *ngIf="currentUser.hasPermission('plans.view')" routerLinkActive="router-link-active">
                    <mat-icon svgIcon="assignment"></mat-icon>
                    <span trans>Plans</span>
                </a>
                <a class="menu-item" routerLink="subscriptions" *ngIf="currentUser.hasPermission('subscriptions.view')" routerLinkActive="router-link-active">
                    <mat-icon svgIcon="subscriptions"></mat-icon>
                    <span trans>Subscriptions</span>
                </a>
            </ng-container>

            <ng-container *ngFor="let item of getCustomSidebarItems()">
                <a class="menu-item" [routerLink]="item.route" *ngIf="currentUser.hasPermission(item.permission)" routerLinkActive="router-link-active">
                    <mat-icon [svgIcon]="item.icon"></mat-icon>
                    <span trans>{{item.name}}</span>
                </a>
            </ng-container>

            <a class="menu-item" routerLink="users" *ngIf="currentUser.hasPermission('users.view')" routerLinkActive="router-link-active">
                <mat-icon svgIcon="person"></mat-icon>
                <span trans>Users</span>
            </a>
            <a class="menu-item" routerLink="roles" *ngIf="currentUser.hasPermission('roles.view')" routerLinkActive="router-link-active">
                <mat-icon svgIcon="people"></mat-icon>
                <span trans>Roles</span>
            </a>
            <a class="menu-item" routerLink="pages" *ngIf="currentUser.hasPermission('pages.view')" routerLinkActive="router-link-active">
                <mat-icon svgIcon="web"></mat-icon>
                <span trans>Pages</span>
            </a>
            <a class="menu-item" routerLink="files" *ngIf="currentUser.hasPermission('files.view')" routerLinkActive="router-link-active">
                <mat-icon svgIcon="insert-drive-file"></mat-icon>
                <span trans>Files</span>
            </a>
            <a class="menu-item" routerLink="translations" *ngIf="currentUser.hasPermission('localizations.view')" routerLinkActive="router-link-active">
                <mat-icon svgIcon="translate"></mat-icon>
                <span trans>Translations</span>
            </a>
            <a class="menu-item" routerLink="mail-templates" *ngIf="currentUser.hasPermission('mail_templates.view')" routerLinkActive="router-link-active">
                <mat-icon svgIcon="mail"></mat-icon>
                <span trans>Mail Templates</span>
            </a>
            <a class="menu-item" routerLink="ads" *ngIf="currentUser.hasPermission('settings.view') && !settings.get('vebto.admin.hideAds')" routerLinkActive="router-link-active">
                <mat-icon svgIcon="ads-custom"></mat-icon>
                <span trans>Ads</span>
            </a>
        </div>
        <div class="version">
            Version: {{settings.get('version')}}
        </div>
    </mat-sidenav>

    <mat-sidenav-content class="content-inner">
        <router-outlet></router-outlet>
    </mat-sidenav-content>
</mat-sidenav-container>